class Timer {
  constructor(callback, delay) {
    this.callback = callback;
    this.delay = delay;
    this.timerId = null;
    this.start = null;
    this.remaining = delay;

    this.resume();
  }

  pause() {
    window.clearTimeout(this.timerId);
    this.remaining -= Date.now() - this.start;
  }

  resume() {
    this.start = Date.now();
    window.clearTimeout(this.timerId);
    this.timerId = window.setTimeout(() => {
      this.callback();
      this.clear();
    }, this.remaining);
  }

  clear() {
    window.clearTimeout(this.timerId);
    this.timerId = null;
    this.start = null;
    this.remaining = null;
  }
}

export default Timer;
